module.exports = __webpack_public_path__ + "images/101_4096.jpg";